var _excluded = ["Component", "validate"];
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { Field, FieldArray } from 'formik';
import Text from './Text';
import Input from './Input';
import Select from './Select';
import Autosuggest from './Autosuggest';
import { isRequired, hasSelection } from './utils';
var validateField = function validateField(value, check, _ref) {
  var required = _ref.required;
  return check && check(value) || required && isRequired(value);
};
var FormField = function FormField(_ref2) {
  var Component = _ref2.Component,
    _validate = _ref2.validate,
    inputProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(Field, _extends({
    validate: function validate(value) {
      return validateField(value, _validate, inputProps);
    }
  }, inputProps, {
    render: function render(_ref3) {
      var field = _ref3.field,
        _ref3$form = _ref3.form,
        errors = _ref3$form.errors,
        touched = _ref3$form.touched,
        values = _ref3$form.values;
      return /*#__PURE__*/React.createElement(Component, _extends({
        error: touched[field.name] && errors[field.name],
        checked: values[field.name] === inputProps.value // needed only for inputs
      }, field, inputProps));
    }
  }));
};
export var TextField = function TextField(props) {
  return /*#__PURE__*/React.createElement(FormField, _extends({
    Component: Text
  }, props));
};
export var SelectField = function SelectField(props) {
  return /*#__PURE__*/React.createElement(FormField, _extends({
    Component: Select
  }, props));
};
export var InputField = function InputField(props) {
  return /*#__PURE__*/React.createElement(FormField, _extends({
    Component: Input
  }, props));
};
export var AutosuggestField = function AutosuggestField(props) {
  return /*#__PURE__*/React.createElement(FormField, _extends({
    Component: Autosuggest
  }, props));
};
export var CheckboxGroupField = function CheckboxGroupField(_ref4) {
  var name = _ref4.name,
    required = _ref4.required,
    title = _ref4.title,
    options = _ref4.options;
  return /*#__PURE__*/React.createElement(FieldArray, {
    name: name,
    render: function render(_ref5) {
      var _ref5$form = _ref5.form,
        values = _ref5$form.values,
        setFieldValue = _ref5$form.setFieldValue;
      var selected = values[name] || [];
      return /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
        className: required ? 'cb-required' : ''
      }, title), options.map(function (opt) {
        var isChecked = selected.find(function (v) {
          return v == opt.value;
        });
        return /*#__PURE__*/React.createElement(InputField, {
          validate: function validate() {
            return required && hasSelection(selected);
          },
          name: name,
          value: opt.value,
          label: opt.label,
          checked: isChecked,
          key: opt.value,
          onChange: function onChange(e) {
            var checked = e.target.checked;
            var isSingleSelect = options.find(function (o) {
              return o.value == opt.value && o.singleSelect;
            });
            if (!checked) setFieldValue(name, selected.filter(function (s) {
              return s !== opt.value;
            }));else if (isSingleSelect) setFieldValue(name, [opt.value]);else setFieldValue(name, [opt.value].concat(_toConsumableArray(selected.filter(function (s) {
              return !options.find(function (o) {
                return o.value == s && o.singleSelect;
              });
            }))));
          }
        });
      }));
    }
  });
};